document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(".alertDismiss").forEach((button) => {
        button.addEventListener("click", () => {
            const alert = button.closest(".alert");
            alert.remove();
        });
    });
});